import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from '../../environments/environment';
import { NewsItem, NewsResponse } from '../interfaces/news.interface';
import { map, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NewsService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  getLatestNews(): Observable<NewsItem[]> {
    return this.http.get<{ news: NewsItem[] }>(`${this.apiUrl}/news`).pipe(
      map(response => response.news || []),
      catchError(error => {
        console.error('Error fetching news:', error);
        // Fallback to mock data if API call fails
        return of(this.getMockNews());
      })
    );
  }

  private getMockNews(): NewsItem[] {
    return [
      {
        id: 1,
        title: '50 world-changing work, We lost in the 2010s',
        date: 'Oct 14, 2023',
        image: 'assets/img/home-two/person1.jpg',
        author: {
          name: 'Sarah Taylor',
          image: 'https://randomuser.me/api/portraits/women/44.jpg'
        }
      },
      {
        id: 2,
        title: 'Don\'t buy a tech gift until you read these rules',
        date: 'Oct 16, 2023',
        image: 'assets/img/home-two/person2.jpg',
        author: {
          name: 'Michel John',
          image: 'https://randomuser.me/api/portraits/men/32.jpg'
        }
      },
      {
        id: 3,
        title: 'The golden rule of buying a phone as a gift',
        date: 'Oct 18, 2023',
        image: 'assets/img/home-two/person3.jpg',
        author: {
          name: 'Lucy Eva',
          image: 'https://randomuser.me/api/portraits/women/22.jpg'
        }
      }
    ];
  }
} 